// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: FGB0rFky-C

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Header from "../../Header"; // plasmic-import: FX7sJMOvuD/component
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component
import NewsLetter from "../../NewsLetter"; // plasmic-import: hz7eRhzEc6/component
import Footer from "../../Footer"; // plasmic-import: WRs9bMrYcz/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: FGB0rFky-C/css

import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: QKCDMAfoLkN/icon
import _3081627JpgAjj7Gy5Eo from "./images/_3081627Jpg.jpg"; // plasmic-import: Ajj7Gy5EO/picture
import _13210Croppedjpg1EGdaukg from "./images/_13210Croppedjpg.jpg"; // plasmic-import: 1E-GDAUKG/picture
import businessTeam5JpgZxvlLy2 from "./images/businessTeam5Jpg.jpg"; // plasmic-import: zxvlLY_-2/picture

createPlasmicElementProxy;

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  root?: p.Flex<"div">;
  header?: p.Flex<typeof Header>;
  h2?: p.Flex<"h2">;
  exploreProductsButton?: p.Flex<typeof Button>;
  validateIdeaButton?: p.Flex<typeof Button>;
  buildIdeaButton?: p.Flex<typeof Button>;
  launchIdeaButton?: p.Flex<typeof Button>;
  newsLetter?: p.Flex<typeof NewsLetter>;
  footer?: p.Flex<typeof Footer>;
};

export interface DefaultHomepageProps {
  className?: string;
}

const $$ = {};

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__kJyGx)}>
            <h2
              data-plasmic-name={"h2"}
              data-plasmic-override={overrides.h2}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.h2
              )}
            >
              {"From Idea To Product"}
            </h2>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__pRFu
              )}
            >
              <React.Fragment>
                <React.Fragment>
                  {
                    "The ultimate app for aspiring entrepreneurs to quickly find "
                  }
                </React.Fragment>
                <span
                  className={"plasmic_default__all plasmic_default__span"}
                  style={{ fontWeight: 700 }}
                >
                  {"handpicked"}
                </span>
                <React.Fragment>
                  {", top-notch products tailored to their startup needs."}
                </React.Fragment>
              </React.Fragment>
            </div>
            <Button
              data-plasmic-name={"exploreProductsButton"}
              data-plasmic-override={overrides.exploreProductsButton}
              className={classNames(
                "__wab_instance",
                sty.exploreProductsButton
              )}
              color={"blue"}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__cPo0N
                )}
              >
                {"Explore Products"}
              </div>
            </Button>
            <div className={classNames(projectcss.all, sty.freeBox___6CuLq)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__jsBnO)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"60%"}
                loading={"lazy"}
                src={{
                  src: _3081627JpgAjj7Gy5Eo,
                  fullWidth: 3000,
                  fullHeight: 2000,
                  aspectRatio: undefined
                }}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__pLo71
                )}
              >
                {
                  "\ud83c\udfaf Validate Your Startup Idea with Confidence! \ud83e\udde0\n\n\ud83d\ude80 Validate your startup idea confidently with StartupPro! Our curated selection of powerful validation tools, from market research to user feedback, will guide you to success. Minimize risks and build a solid business concept with ease. \ud83e\udde0\ud83d\udca1"
                }
              </div>
              <Button
                data-plasmic-name={"validateIdeaButton"}
                data-plasmic-override={overrides.validateIdeaButton}
                className={classNames("__wab_instance", sty.validateIdeaButton)}
                color={"link"}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__fCjwg
                  )}
                >
                  {"Validate your idea >"}
                </div>
              </Button>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__pvrE)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__aJfnt)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                loading={"lazy"}
                src={{
                  src: _13210Croppedjpg1EGdaukg,
                  fullWidth: 7500,
                  fullHeight: 3592,
                  aspectRatio: undefined
                }}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__svhe9
                )}
              >
                {
                  "\ud83d\udd27 Bring Your Idea to Life! \ud83d\ude80\n\nFrom idea to reality, our cutting-edge tools empower you every step of the way. Unleash creativity and turn your vision into a successful startup. Get started now! \ud83d\udd27\ud83c\udfd7\ufe0f"
                }
              </div>
              <Button
                data-plasmic-name={"buildIdeaButton"}
                data-plasmic-override={overrides.buildIdeaButton}
                className={classNames("__wab_instance", sty.buildIdeaButton)}
                color={"link"}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ofZan
                  )}
                >
                  {"Build your idea >"}
                </div>
              </Button>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox___2WnYx)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__hGuWc)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                loading={"lazy"}
                src={{
                  src: businessTeam5JpgZxvlLy2,
                  fullWidth: 6251,
                  fullHeight: 4168,
                  aspectRatio: undefined
                }}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fpW5
                )}
              >
                {
                  "\ud83d\ude80 Launch Your Idea to Success! \ud83d\udca1\n\nDiscover our powerful suite of tools designed to guide entrepreneurs through every step of their startup launch. From strategic planning to post-launch analytics, we're here to empower you on your journey to success! \ud83c\udf1f\ud83d\udd27\ud83d\udcca"
                }
              </div>
              <Button
                data-plasmic-name={"launchIdeaButton"}
                data-plasmic-override={overrides.launchIdeaButton}
                className={classNames("__wab_instance", sty.launchIdeaButton)}
                color={"link"}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lYc0P
                  )}
                >
                  {"Launch your idea >"}
                </div>
              </Button>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__g3Kn4)}>
              <NewsLetter
                data-plasmic-name={"newsLetter"}
                data-plasmic-override={overrides.newsLetter}
                className={classNames("__wab_instance", sty.newsLetter)}
              />
            </div>
          </div>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "h2",
    "exploreProductsButton",
    "validateIdeaButton",
    "buildIdeaButton",
    "launchIdeaButton",
    "newsLetter",
    "footer"
  ],
  header: ["header"],
  h2: ["h2"],
  exploreProductsButton: ["exploreProductsButton"],
  validateIdeaButton: ["validateIdeaButton"],
  buildIdeaButton: ["buildIdeaButton"],
  launchIdeaButton: ["launchIdeaButton"],
  newsLetter: ["newsLetter"],
  footer: ["footer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: typeof Header;
  h2: "h2";
  exploreProductsButton: typeof Button;
  validateIdeaButton: typeof Button;
  buildIdeaButton: typeof Button;
  launchIdeaButton: typeof Button;
  newsLetter: typeof NewsLetter;
  footer: typeof Footer;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHomepage__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    h2: makeNodeComponent("h2"),
    exploreProductsButton: makeNodeComponent("exploreProductsButton"),
    validateIdeaButton: makeNodeComponent("validateIdeaButton"),
    buildIdeaButton: makeNodeComponent("buildIdeaButton"),
    launchIdeaButton: makeNodeComponent("launchIdeaButton"),
    newsLetter: makeNodeComponent("newsLetter"),
    footer: makeNodeComponent("footer"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
